import {initFormRecaptcha} from '../helpers/recaptcha.js';


(() => {
    document.addEventListener('scrollToTopForm', function () {
        const element = document.querySelector('#form');
        if (element) {
            element.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    });

    document.addEventListener('DOMContentLoaded', initFormRecaptcha);


})();
